import React from 'react';
import PropTypes from 'prop-types';

import { toTitleCase } from '../../utils/stringManipulations';
import I18N from '../../I18N';

const LiveRecordInfoRow = ({ isRecording, isLive, teamNameLive, teamNameRecord })=> {
  const by = ` ${toTitleCase(I18N.t("BY"))}: `

  return (
    <div className="single-site__info__live-record">
      {isRecording &&
        <div className="single-site__info__live-record__record">
          <div className="single-site__info__live-record__record__circle"/>
          <span style={{ padding: "0px 5px" }}>{I18N.t("RECORDING").toUpperCase()}</span>
          <span style={{ paddingLeft: "5px", fontWeight: "700" }}>{teamNameRecord}</span>
        </div>
      }
      {isLive && 
        <div className="single-site__info__live-record__team">
          <span className="single-site__info__live-record__live">{I18N.t("LIVE_NOW").toUpperCase()}</span>
          <span>{by}</span>
          <span style={{ paddingLeft: "5px", fontWeight: "700" }}>{teamNameLive}</span>
        </div>
      }
    </div>
  );
};

LiveRecordInfoRow.propTypes = {
  isLive: PropTypes.bool, 
  isRecording: PropTypes.bool, 
  teamName: PropTypes.string
};

LiveRecordInfoRow.defaultProps = {
  isLive: false, 
  isRecording: false, 
  teamName: ""
};

export default LiveRecordInfoRow;